export class OperationIdRequest {
    operationName?:string
    operationId?: number;
    constructor(operationName?:string,operationId?: number){
        this.operationName = operationName
        this.operationId = operationId
    }
}